import { render } from "./HeaderCRM.vue?vue&type=template&id=4d13b8e0"
import script from "./HeaderCRM.vue?vue&type=script&lang=js"
export * from "./HeaderCRM.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__